
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casino/fairness-rush",
      function () {
        return require("private-next-pages/casino/fairness-rush/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casino/fairness-rush"])
      });
    }
  